import { ApiConfiguration } from '../api-configuration';
import { createSupportWidgetConfig } from '../support-widget-config';
import { API_PATH_PREFIX_ADMIN, API_PATH_PREFIX_AUTHENTICATION, API_PATH_PREFIX_USER } from '../api-path-prefixes';

const API_ORIGIN = 'https://api.lexplus.ch';

/**
 * This global environment variables are equal to production.
 * The GLOBAL constant shouldn't be imported directly. Only import them via an environment variable.
 */
export const GLOBALS_ADMIN = {
  /**
   * Environment name.
   */
  name: 'production',

  /**
   * Can be used to check if it is the one and only production environment.
   */
  production: true,

  /**
   * API Base URL. Defined per customer in base.ts environment file.
   */
  apiConfiguration: {
    baseUrl: `${API_ORIGIN}${API_PATH_PREFIX_ADMIN}`,
    baseUrlAuth: `${API_ORIGIN}${API_PATH_PREFIX_AUTHENTICATION}`,
    baseUrlUser: `${API_ORIGIN}${API_PATH_PREFIX_USER}`,
    publicApiKey: '',
  } as ApiConfiguration,

  /**
   * Digitale Menschen support widget. Loaded on every page, signed in or not, so a
   * user who cannot get past the sign-in screen can still report that.
   */
  support: createSupportWidgetConfig('Lexplus Admin'),

  /**
   * Language configuration, setting the default language and provide a list of available languages in the app.
   */
  languagesDefault: 'de',
  languagesAvailable: ['de', 'fr', 'it'],

  /**
   * Logging settings for NGXS and general.
   */
  isLoggingEnabled: {
    logger: false,
    ngxs: false,
  },

  /**
   * Sentry
   */
  sentryDsn: {
    app: '',
  },

  /**
   * Debounce time for UI elements
   */
  uiDebounceTime: 300,
};
